import { InjectionToken } from '@angular/core';

/**
 * Base URL for the Chat API (legacy .NET chat service).
 *
 * The consuming application must provide this token:
 * ```ts
 * { provide: CHAT_API_BASE_URL, useValue: environment.apiUrl.chat }
 * ```
 */
export const CHAT_API_BASE_URL = new InjectionToken<string>('CHAT_API_BASE_URL');

/**
 * Base URL for the Connect API (our NestJS connect service).
 *
 * The consuming application must provide this token:
 * ```ts
 * { provide: CONNECT_API_BASE_URL, useValue: environment.apiUrl.connect }
 * ```
 */
export const CONNECT_API_BASE_URL = new InjectionToken<string>('CONNECT_API_BASE_URL');

/**
 * ICE servers for call peer connections. Optional — if the consuming app
 * doesn't provide it, calls fall back to public STUN-only servers (direct
 * peer-to-peer NAT traversal only, no relay). STUN alone cannot establish
 * a media path on many real-world networks (symmetric NAT, restrictive
 * corporate firewalls) — the call connects, silently retries ICE for a
 * while (heard as "no sound for a bit, then it comes back" while a working
 * candidate pair is eventually found — or connects then repeatedly drops
 * as it flaps between working/non-working paths). A TURN server (relay
 * fallback for when a direct path can't be found at all) fixes this
 * class of issue outright; once one is provisioned, wire it up with:
 * ```ts
 * { provide: CONNECT_ICE_SERVERS, useValue: [
 *     { urls: 'stun:stun.l.google.com:19302' },
 *     { urls: 'turn:your-turn-host:3478', username: '...', credential: '...' },
 * ] }
 * ```
 */
export const CONNECT_ICE_SERVERS = new InjectionToken<RTCIceServer[]>('CONNECT_ICE_SERVERS');
